export const DefaultDateFormat = 'YYYY/MM/DD';
export const DefaultDateTimeFormat = 'YYYY/MM/DD HH:mm:ss';
export const DefaultDatePickerFormat = 'yyyy/MM/dd'; // Because it handles the date format strings differently to MomentJS
export const DefaultDateTimeSecondsFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const DefaultDateFriendlyFormat = 'DD MMMM yyyy';
export const DefaultDatePickerFriendlyFormat = 'dd MMMM yyyy';
export const DefaultParamsDateFormat = 'YYYY-MM-DD'